import { FontAwesomeIcon } from "./FontAwesomeIcon"
import { faTruck } from "@fortawesome/free-solid-svg-icons"

export const Truck = (props) => {
  return <FontAwesomeIcon faIcon={faTruck} {...props} />
}
